import './IngestionHeader.scss';
import {Box, Typography} from '@mui/material';
import ArrTooltipWrapper from '../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {t} from 'i18next';
import ArrButton from '../../common/arr-button/ArrButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {ReactComponent as ExportIcon} from '../../../assets/images/upload.svg';
import {useNavigate} from 'react-router-dom';
interface IngestionHeaderProps {
  onClearAll?: (Key: boolean) => void;
  handleExport?: () => void;
}
const IngestionHeader: React.FC<IngestionHeaderProps> = ({
  onClearAll,
  handleExport,
}) => {
  const navigate = useNavigate();
  const handleRefresh = () => {
    onClearAll?.(true); // Pass your number here
  };

  return (
    <Box className="view-ingestion-header-landing">
      <Box className="view-ingestion-title">
        <Typography
          className="typo-text headline3_size view-ingestion-title-text"
          data-testid={`ingestion-header-title`}>
          {t('ingestions.mapped.title')}
        </Typography>

        <ArrTooltipWrapper
          title={t('ingestions.mapped.infoIngestions.modalTitle')}
          trigger={
            <InfoOutlinedIcon
              className="view-ingestion-info-icon"
              fontSize="medium"
            />
          }
        >
          {t('ingestions.mapped.infoIngestions.overview')}
          <ul
            data-testid={`ingestion-header-step1-step2-step3-step4-step5-step6-step7`}>
            <li data-testid={`ingestion-header-step1`}>
              <span data-testid={`ingestion-header-step1-text`}>{t('ingestions.mapped.infoIngestions.steps.step1')}</span>
            </li>
            <li data-testid={`ingestion-header-step2`}>{t('ingestions.mapped.infoIngestions.steps.step2')}</li>
            <li data-testid={`ingestion-header-step3`}>{t('ingestions.mapped.infoIngestions.steps.step3')}</li>
            <li data-testid={`ingestion-header-step4`}>{t('ingestions.mapped.infoIngestions.steps.step4')}</li>
            <li data-testid={`ingestion-header-step5`}>{t('ingestions.mapped.infoIngestions.steps.step5')}</li>
            <li data-testid={`ingestion-header-step6`}>{t('ingestions.mapped.infoIngestions.steps.step6')}</li>
            <li data-testid={`ingestion-header-step7`}>{t('ingestions.mapped.infoIngestions.steps.step7')}</li>
          </ul>

          <p data-testid={`ingestion-header-note`}>{t('ingestions.mapped.infoIngestions.steps.note')}</p>
          <h3 data-testid={`ingestion-header-title-btn`}>{t('ingestions.mapped.ingestionErrors.existing.title')}</h3>
          <p data-testid={`ingestion-header-description`}>{t('ingestions.mapped.ingestionErrors.existing.description')}</p>
          <h3 data-testid={`ingestion-header-title-button`}>{t('ingestions.mapped.ingestionErrors.tileView.title')}</h3>
          <p data-testid={`ingestion-header-description-text`}>{t('ingestions.mapped.ingestionErrors.tileView.description')}</p>
          <h3 data-testid={`ingestion-header-title-icon`}>{t('ingestions.mapped.ingestionErrors.gridView.title')}</h3>
          <p data-testid={`ingestion-header-description-btn`}>{t('ingestions.mapped.ingestionErrors.gridView.description')}</p>
          <h3 data-testid={`ingestion-header-title-link`}>{t('ingestions.mapped.ingestionErrors.newIngestions.title')}</h3>
          <p data-testid={`ingestion-header-description-button`}>
            {t('ingestions.mapped.ingestionErrors.newIngestions.description')}
          </p>
        </ArrTooltipWrapper>
      </Box>
      <Box gap={1} className="view-ingestion-button-section">
        <ArrButton
          aria-label={t('ingestions.mapped.btnText')}
          type="submit"
          variant="primary"
          title="Drawer"
          size="small"
          onClick={() => navigate('/Ingestion/Wizard')}
          dataTestId="ingestion-header-btn-text-button">
          {t('ingestions.mapped.btnText')}
        </ArrButton>
        <ArrButton
          onClick={handleRefresh}
          aria-label={t('ingestions.refresh')}
          variant="secondary"
          size="small"
          dataTestId="ingestion-header-refresh-button">
          {t('ingestions.refresh')}
        </ArrButton>
        <ArrButton
          startIcon={<ExportIcon className="upload-icon" />}
          variant="secondary"
          onClick={handleExport}
          size="small"
          dataTestId="ingestion-header-export-button">
          {t('ingestions.export')}
        </ArrButton>
      </Box>
    </Box>
  );
};

export default IngestionHeader;
